/**
 * Вырезает шаблон adfox-баннера из HTML
 * @param html - исходный HTML
 * @returns - html
 */
export const removeAdfoxParams = (html: string) => {
  return html.replace(/<div[^>]*?class="__adfox">.*?<\/div>/gis, '');
};
